import { HalloweenIcon } from './HalloweenIcon';

/**
 * author: Austin Andrews
 * id CE482051-152D-4A7F-A696-74D8CD398FEF
 * name halloween
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/halloween.svg
 * tags
 * - Holiday 
 */
export const JackOLanternIcon = HalloweenIcon;
export default JackOLanternIcon